module.exports = __webpack_public_path__ + "fonts/montserrat-v12-latin-500italic.4590ebba.woff2";